import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, take } from 'rxjs/operators';
import { CatalogTransferAction, CreateTransferAction, EditTransferAction, TransferActionTypes, CreateCalendarTransferAction, UnlockEditTransferAction, ValidateTransferAction, ViewTransferAction, ViewCalendarTransferAction, EditCalendarTransferAction, DeleteCalendarTransferAction, DeleteTransferAction } from '../actions/transfer-actions';
import { TransferService } from '../../services/transfer.service';
import { AppStore, getAppSelection, SnackbarErrorAction } from '@alfresco/aca-shared/store';
import { Store } from '@ngrx/store';
import { SMTConfirmDialogComponent } from 'projects/alden-extension/src/lib/dialogs/confirm/confirm.dialog';
import { MatDialog } from '@angular/material/dialog';
import { UdeuStatus } from '../../model/classes/udeu-status';
import { UDEU_TRANSFER_DRAFT_STATUS } from '../../model/contants/deusto';
import { ReloadCustomListTableAction } from 'projects/alden-extension/src/lib/store/actions/alden.actions';
import { Router } from '@angular/router';
import { UdeuService } from '../../services/udeu.service';


@Injectable()
export class TransferEffects {
  constructor(
    private store: Store<AppStore>,
    private actions$: Actions,
    private transferService: TransferService,
    private dialog: MatDialog,
    private router: Router,
    private udeuService: UdeuService,
  ) { }

  CreateCalendarTransfer$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<CreateCalendarTransferAction>(TransferActionTypes.CreateCalendarTransfer),
        map((_action) => {
          this.transferService.openCreateTransferCalendar()
        })
      ),
    { dispatch: false }
  );

  viewCalendarTransfer$ = createEffect(
      () =>
        this.actions$.pipe(
          ofType<ViewCalendarTransferAction>(TransferActionTypes.ViewCalendarTransfer),
          map((action) => {
            this.openTransferCalendarDialog(action, TransferActionTypes.ViewCalendarTransfer);
          })
        ),
      { dispatch: false }
  );

  editCalendarTransfer$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<EditCalendarTransferAction>(TransferActionTypes.EditCalendarTransfer),
        map((action) => {
          this.openTransferCalendarDialog(action, TransferActionTypes.EditCalendarTransfer);
        })
      ),
    { dispatch: false }
  );

  deleteCalendarTransfer$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<DeleteCalendarTransferAction>(TransferActionTypes.DeleteCalendarTransfer),
        map((action) => {
          if (action && action.payload && action.payload.length > 0) {
            this.udeuService.deleteNode(action.payload);
          } else {
            this.store
              .select(getAppSelection)
              .pipe(take(1))
              .subscribe((selection) => {
                if (selection && selection.count > 0) {
                  this.udeuService.deleteNode(selection.nodes);
                }
              });
          }
        })
      ),
    { dispatch: false }
  );

  createTransfer$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<CreateTransferAction>(TransferActionTypes.CreateTransfer),
        map((_action) => {
          this.transferService.openCreateTransfer()
        })
      ),
    { dispatch: false }
  );

  editTransfer$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<EditTransferAction>(TransferActionTypes.EditTransfer),
        map((action) => {
          this.openCreateTransferDialog(action, TransferActionTypes.EditTransfer)
        })
      ),
    { dispatch: false }
  );

  validateTransfer$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<ValidateTransferAction>(TransferActionTypes.ValidateTransfer),
        map((action) => {
          this.openCreateTransferDialog(action, TransferActionTypes.ValidateTransfer)
        })
      ),
    { dispatch: false }
  );

  catalogTransfer$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<CatalogTransferAction>(TransferActionTypes.CatalogTransfer),
        map((action) => {
          this.openCreateTransferDialog(action, TransferActionTypes.CatalogTransfer)
        })
      ),
    { dispatch: false }
  );

  viewTransfer$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<ViewTransferAction>(TransferActionTypes.ViewTransfer),
        map((action) => {
          this.openCreateTransferDialog(action, TransferActionTypes.ViewTransfer)
        })
      ),
    { dispatch: false }
  );

  unlockEditTransfer$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<UnlockEditTransferAction>(TransferActionTypes.UnlockEditTransfer),
        map((action: any) => {
          if (action && action.payload && action.payload.length > 0) {
            this.unlockTransfer(action);
          } else {
            this.store
              .select(getAppSelection)
              .pipe(take(1))
              .subscribe((selection) => {
                if (selection && selection.count > 0) {
                  const UUID = selection.nodes.map((nodeEntry) => nodeEntry.entry.id)[0];
                  this.unlockTransfer(UUID);
                }
              });
          }
        })
      ),
    { dispatch: false }
  );

  deleteTransfer$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType<DeleteTransferAction>(TransferActionTypes.DeleteTransfer),
        map((action) => {
          if (action && action.payload && action.payload.length > 0) {
            this.udeuService.deleteNode(action.payload);
          } else {
            this.store
              .select(getAppSelection)
              .pipe(take(1))
              .subscribe((selection) => {
                if (selection && selection.count > 0) {
                  this.udeuService.deleteNode(selection.nodes);
                }
              });
          }
        })
      ),
    { dispatch: false }
  );

  private unlockTransfer(UUID: string) {
    const dialogRef = this.dialog.open(SMTConfirmDialogComponent, {
      data: { 
        title: "DEUSTO.ACTIONS.UNLOCK_EDIT_TRANSFER.TITLE",
        message: "DEUSTO.ACTIONS.UNLOCK_EDIT_TRANSFER.MESSAGE", 
        noLabel: "DEUSTO.ACTIONS.UNLOCK_EDIT_TRANSFER.NO_LABEL", 
        yesLabel: "DEUSTO.ACTIONS.UNLOCK_EDIT_TRANSFER.YES_LABEL",
      },
      minWidth: '250px'
    });
    
    dialogRef.afterClosed().subscribe((result) => {
      if (result !== false) {      
        const udeuStatus = new UdeuStatus(UDEU_TRANSFER_DRAFT_STATUS, result);
        this.udeuService.updateStatus(UUID, udeuStatus).then(() => {
          const route = '/viewer/transfers';
          this.router.url === route ? this.store.dispatch(new ReloadCustomListTableAction(false)) : this.router.navigate([route]);
        })
        .catch((err) => {
          console.error("ERROR", err);
          this.store.dispatch(new SnackbarErrorAction('Hubo un error inesperado. Contacte con el administrador.'));
        });
      }
    });
  }

  private openTransferCalendarDialog(action: any, transferActionType: TransferActionTypes) {
    if (action && action.payload && action.payload.length > 0) {
      this.transferService.openTransferCalendarDialog(action, transferActionType);
    } else {
      this.store
        .select(getAppSelection)
        .pipe(take(1))
        .subscribe((selection) => {
          if (selection && selection.count > 0) {
            const UUID = selection.nodes.map((nodeEntry) => nodeEntry.entry.id)[0];
            this.transferService.openTransferCalendarDialog(UUID, transferActionType);
          }
        });
    }
  }

  private openCreateTransferDialog(action: any, transferActionType: TransferActionTypes) {
    if (action && action.payload && action.payload.length > 0) {
      this.transferService.openCreateTransfer(action, transferActionType);
    } else {
      this.store
        .select(getAppSelection)
        .pipe(take(1))
        .subscribe((selection) => {
          if (selection && selection.count > 0) {
            const UUID = selection.nodes.map((nodeEntry) => nodeEntry.entry.id)[0];
            this.transferService.openCreateTransfer(UUID, transferActionType);
          }
        });
    }
  }

}
